import { camelToTitleCase } from '../utils/camelToTitleCase.js';

const recordTypeLabelTokenOverrides = {
  api: 'API',
  crm: 'CRM',
  eeoc: 'EEOC',
  sla: 'SLA',
  sku: 'SKU'
};

const buildRecordTypeLabel = (recordTypeKey) => {
  return camelToTitleCase(recordTypeKey)
    .split(' ')
    .map((token) => recordTypeLabelTokenOverrides[token.toLowerCase()] || token)
    .join(' ');
};

export const recordTypeKeys = [
  'accessReview',
  'accessToken',
  'accountingPeriod',
  'action',
  'activity',
  'ad',
  'adCampaign',
  'address',
  'adGroup',
  'alert',
  'announcement',
  'apiKey',
  'application',
  'appointment',
  'approval',
  'asset',
  'attachment',
  'attendanceRecord',
  'attendee',
  'attributionEvent',
  'audience',
  'auditLog',
  'backlogItem',
  'balanceSheetReport',
  'bankAccount',
  'bankFeedAccount',
  'bankFeedTransaction',
  'benefitPlan',
  'bill',
  'billLine',
  'board',
  'branch',
  'budget',
  'build',
  'businessUnit',
  'calendar',
  'calendarEvent',
  'call',
  'campaign',
  'candidate',
  'cart',
  'case',
  'cashFlowStatementReport',
  'catalog',
  'category',
  'changeRequest',
  'channel',
  'charge',
  'checklist',
  'checkout',
  'collection',
  'column',
  'comment',
  'commit',
  'company',
  'compensation',
  'connection',
  'connector',
  'contact',
  'contactMethod',
  'contract',
  'contractAmendment',
  'conversation',
  'costCenter',
  'coupon',
  'creativeAsset',
  'creditNote',
  'crmAccount',
  'customer',
  'customField',
  'customObject',
  'dashboard',
  'database',
  'dataset',
  'dataSource',
  'dataSync',
  'deal',
  'debitNote',
  'demandPlan',
  'department',
  'dependency',
  'dependent',
  'deployment',
  'device',
  'dimension',
  'discount',
  'dispute',
  'division',
  'document',
  'drive',
  'eeocResponse',
  'email',
  'emailCampaign',
  'emailTemplate',
  'employee',
  'employeePayrollRun',
  'employerBenefit',
  'employment',
  'endpoint',
  'engagement',
  'engagementType',
  'environment',
  'epic',
  'escalation',
  'estimate',
  'event',
  'exchangeRate',
  'expense',
  'expenseReport',
  'experiment',
  'exportJob',
  'featureRequest',
  'file',
  'fileVersion',
  'fiscalYear',
  'folder',
  'form',
  'formSubmission',
  'fulfillment',
  'generalLedgerTransaction',
  'goodsReceipt',
  'group',
  'importJob',
  'incident',
  'incomeStatementReport',
  'integration',
  'interview',
  'interviewStage',
  'inventoryItem',
  'inventoryLevel',
  'inventoryTransfer',
  'invitation',
  'invoice',
  'invoiceLine',
  'issue',
  'item',
  'job',
  'jobApplication',
  'jobPosting',
  'journalEntry',
  'journalLine',
  'journey',
  'keyResult',
  'keyword',
  'knowledgeArticle',
  'label',
  'landingPage',
  'lead',
  'ledgerAccount',
  'legalEntity',
  'list',
  'location',
  'mapping',
  'meeting',
  'membership',
  'mention',
  'mergeRequest',
  'message',
  'metric',
  'milestone',
  'model',
  'monitor',
  'note',
  'notification',
  'objective',
  'offer',
  'office',
  'opportunity',
  'order',
  'orderLine',
  'organization',
  'page',
  'payGroup',
  'payment',
  'paymentIntent',
  'paymentMethod',
  'paymentTerm',
  'payout',
  'payrollRun',
  'permission',
  'phoneNumber',
  'pipeline',
  'policy',
  'portfolio',
  'position',
  'price',
  'priceBook',
  'problem',
  'product',
  'productVariant',
  'program',
  'project',
  'proposal',
  'purchaseOrder',
  'purchaseOrderLine',
  'purchaseRequisition',
  'query',
  'queue',
  'quote',
  'quoteLine',
  'reaction',
  'reconciliation',
  'recording',
  'refreshToken',
  'refund',
  'reimbursement',
  'rejectionReason',
  'release',
  'renewal',
  'report',
  'repository',
  'requestForQuote',
  'resourceAllocation',
  'return',
  'returnItem',
  'role',
  'runbook',
  'salesOrder',
  'salesOrderLine',
  'satisfactionResponse',
  'schedule',
  'scorecard',
  'screeningQuestion',
  'secret',
  'segment',
  'service',
  'serviceAccount',
  'serviceRequest',
  'session',
  'settlement',
  'shipment',
  'shipmentItem',
  'signatureRequest',
  'sku',
  'slaPolicy',
  'sprint',
  'stage',
  'status',
  'stockMovement',
  'subscriber',
  'subscription',
  'subscriptionPlan',
  'subsidiary',
  'subtask',
  'supplierContract',
  'supplyPlan',
  'syncState',
  'tag',
  'task',
  'taxCode',
  'taxRate',
  'team',
  'template',
  'thread',
  'ticket',
  'timeOffBalance',
  'timeOffRequest',
  'timesheet',
  'timesheetApproval',
  'timesheetEntry',
  'timezoneSetting',
  'touchpoint',
  'trackingCategory',
  'transaction',
  'trigger',
  'unknownObject',
  'user',
  'userProfile',
  'vendor',
  'vendorCatalog',
  'vendorCredit',
  'view',
  'viewerAssignment',
  'vulnerability',
  'warehouse',
  'webhookEndpoint',
  'webhookEvent',
  'workflow',
  'workflowRun',
  'workOrder',
  'workspace'
];

export const recordTypes = Object.freeze(
  recordTypeKeys.reduce((acc, key) => {
    acc[key] = buildRecordTypeLabel(key);
    return acc;
  }, {})
);

export const recordTypeOptions = recordTypeKeys.map((value) => ({
  value,
  label: recordTypes[value]
}));

export const isLegacyRecordTypeKey = (value) => {
  return typeof value === 'string' && value.includes('.');
};
